import angular from 'angular';
import { iframeSetDimension } from './util/iframeSetDimension';

export const loadModule = () =>
  angular.module('app').directive('iframeSetDimension', iframeSetDimension);
